import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './AuthorDetail.css';
import { getWriterById, getItemListByUserId } from "../../api";
import config from '../../config';

const AuthorDetail = () => {
  const { id } = useParams();
  const [authorData, setAuthorData] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Yazar bilgilerini al
        const writerResponse = await getWriterById(id);
        if (writerResponse.status) {
          setAuthorData(writerResponse.data);
          console.log(writerResponse.data);
        }

        // Yazarın maddelerini al
        const articlesResponse = await getItemListByUserId(id);
        if (articlesResponse.status) {
          setArticles(articlesResponse.data);
          console.log(articlesResponse.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  if (loading) {
    return <div className="author-detail-loading">Yükleniyor...</div>;
  }

  if (!authorData) {
    return <div className="author-detail-error">Yazar bulunamadı.</div>;
  }

  return (
    <div className="author-detail-container">
      <div className="author-detail-header">
        <div className="author-detail-info">
          <img 
            src={config.userAuthApiUrl + authorData.profileImageUrl} 
            alt="Profil Resmi" 
            className="author-detail-profile-image"
           
          />
          <h1 className="author-detail-name">
          {authorData.title &&authorData.title} {authorData.name} {authorData.surname}
          </h1>
         

 
        </div>
      </div>

      <div className="author-detail-content">
        {authorData.cv && (
          <div className="author-detail-biography">
            <h2 className="author-detail-section-title">Biyografi</h2>
            <p className="author-detail-text">{authorData.cv}</p>
          </div>
        )}

        <div className="author-detail-articles">
          <h2 className="author-detail-section-title">
           {authorData.name} {authorData.surname} Maddeleri <span className="article-count">({articles.length})</span>
          </h2>
          <div className="author-detail-articles-list">
            {articles.map((article, index) => (
              <Link 
                to={`/article/${article.id}`}
                key={index} 
                className="author-detail-article-item"
              >
                <div className="article-header">
                  <h3 className="author-detail-article-title">{article.title}</h3>
                  {article.createdAt && (
                    <span className="article-date">
                      {new Date(article.createdAt).toLocaleDateString('tr-TR')}
                    </span>
                  )}
                </div>
                {article.definition && (
                  <p className="author-detail-article-summary">{article.definition}</p>
                )}
              </Link>
            ))}
          </div>
        </div>

        {articles.length === 0 && (
          <div className="author-detail-no-articles">
            <p>Bu yazara ait madde bulunmamaktadır.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthorDetail; 